// extracted by mini-css-extract-plugin
export var tags = "response-module--tags--bZ-q8";
export var response = "response-module--response--2V4NG";
export var scoreSection = "response-module--scoreSection--141N8";